$('[data-countdown]').each(function() {
    var $this = $(this);
    var finalDate = $(this).data('countdown');
    var format = $(this).data('format');
    $this.countdown(finalDate, {defer: true}).on('update.countdown', function(event) {
        $this.html(event.strftime(format));
    }).countdown('start');
});
